import React from "react";
import { ChevronRight } from "lucide-react";

/**
 * DisclosureRow — issue #750 § 5.7. The "one disclosure rule for inputs"
 * #699 asks for: more than four inputs on a screen means the ones past the
 * first fold go behind one of these.
 */
export function DisclosureRow({
  title,
  subLabel = null,
  size = "default", // "default" (52px) | "lg" (56px)
  onClick,
  className = "",
  "data-testid": testId,
  ...rest
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`flex items-center justify-between w-full ${className}`}
      style={{
        minHeight: size === "lg" ? 56 : 52,
        background: "var(--nw-surface)",
        borderRadius: "var(--nw-radius-card)",
        border: "1px solid var(--nw-line)",
        padding: "0 14px",
        textAlign: "left",
        cursor: onClick ? "pointer" : "default",
      }}
      {...rest}
    >
      <span style={{ minWidth: 0 }}>
        <span className="nw-body-strong" style={{ display: "block" }}>
          {title}
        </span>
        {subLabel && (
          <span className="nw-help" style={{ display: "block" }}>
            {subLabel}
          </span>
        )}
      </span>
      <ChevronRight
        size={size === "lg" ? 20 : 18}
        style={{ color: "var(--nw-ink-faint)", flexShrink: 0, marginLeft: 12 }}
        aria-hidden="true"
      />
    </button>
  );
}

export default DisclosureRow;
